import { apiV2, errorHandler } from "./index";
import { API_ERROR, DELETE_ADMIN, DELETE_ADMIN_ERROR, DELETE_ADMIN_SUCCESS, FETCH_ALL_ADMINS, FETCH_ALL_ADMINS_ERROR, FETCH_ALL_ADMINS_SUCCESS, FETCH_ONE_ADMIN, FETCH_ONE_ADMIN_ERROR, FETCH_ONE_ADMIN_SUCCESS, RESET_PASSWORD_ADMIN, RESET_PASSWORD_ADMIN_ERROR, RESET_PASSWORD_ADMIN_SUCCESS, SAVE_ADMIN, SAVE_ADMIN_ERROR, SAVE_ADMIN_SUCCESS, UPDATE_PROFILE_ADMIN, UPDATE_PROFILE_ADMIN_ERROR, UPDATE_PROFILE_ADMIN_SUCCESS } from "../constants/ActionTypes";
import Swal from "sweetalert2";
import SessionHelper from "../components/Helper/SessionHelper";

export function fetchAllAdmins() {
    return function (dispatch) {
        dispatch({
            type: FETCH_ALL_ADMINS
        });

        apiV2.get('/admins')
            .then((response) => {
                dispatch({
                    type: FETCH_ALL_ADMINS_SUCCESS,
                    payload: response.data.objects
                })
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ALL_ADMINS_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function saveAdmin(data, onSuccess) {
    return function (dispatch) {
        dispatch({
            type: SAVE_ADMIN
        });

        const adminData = {
            admin_name: data.admin_name,
            admin_email: data.admin_email,
            admin_image: data.admin_image,
            admin_roles: data.roles,
        };

        if (data.admin_password) {
            adminData.admin_password = data.admin_password;
            adminData.admin_password_confirmation = data.admin_password_confirmation;
        }

        const request = data.admin_id
            ? apiV2.put(`/admins/${data.admin_id}`, adminData)
            : apiV2.post('/admins', adminData);

        request
            .then((response) => {
                dispatch({
                    type: SAVE_ADMIN_SUCCESS,
                    payload: data
                });
                Swal.fire({
                    icon: "success",
                    title: "Admin user saved!",
                    timer: 2000
                }).then(() => {
                    onSuccess?.();
                });
            })
            .catch((error) => {
                dispatch({
                    type: SAVE_ADMIN_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function deleteAdmin(admin_id) {
    return function (dispatch) {
        dispatch({
            type: DELETE_ADMIN
        });

        apiV2.delete(`/admins/${admin_id}`)
            .then((response) => {
                dispatch({
                    type: DELETE_ADMIN_SUCCESS,
                    payload: admin_id
                });
                Swal.fire({
                    icon: "success",
                    title: "Admin user Deleted!",
                    timer: 2000
                });
            })
            .catch((error) => {
                dispatch({
                    type: DELETE_ADMIN_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function fetchOneAdmin(admin_id) {
    return function (dispatch) {
        dispatch({
            type: FETCH_ONE_ADMIN
        });

        apiV2.get(`/admins/${admin_id}`)
            .then((response) => {
                dispatch({
                    type: FETCH_ONE_ADMIN_SUCCESS,
                    payload: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ONE_ADMIN_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function resetPasswordAdmin(admin_id) {
    return function (dispatch) {
        dispatch({
            type: RESET_PASSWORD_ADMIN
        });

        apiV2.patch(`/admins/${admin_id}/reset-password`)
            .then((response) => {
                dispatch({
                    type: RESET_PASSWORD_ADMIN_SUCCESS,
                    payload: admin_id
                });
                Swal.fire({
                    icon: "success",
                    title: "Password reseted!",
                    html: "The new password is: <b>" + (response.data.password || response.data) + "</b>",
                    confirmButtonText: "Ok",
                });
            })
            .catch((error) => {
                dispatch({
                    type: RESET_PASSWORD_ADMIN_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}

export function updateProfile(data, onSuccess) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_PROFILE_ADMIN
        });

        let requestPayload;
        let requestConfig = {};

        let request;

        if (data.profile_image instanceof File) {
            // Use FormData when there's an actual file to upload
            // Laravel method spoofing: POST with _method=PUT for multipart/form-data
            const formData = new FormData();
            formData.append('_method', 'PUT');
            formData.append('admin_name', data.admin_name);
            formData.append('admin_email', data.admin_email);
            formData.append('profile_image', data.profile_image);
            if (data.admin_password && data.admin_password.trim() !== '') {
                formData.append('admin_password', data.admin_password.trim());
                formData.append('admin_password_confirmation', data.admin_password_confirmation?.trim() || '');
            }
            request = apiV2.post('/admins/profile', formData, requestConfig);
        } else {
            requestPayload = {
                admin_name: data.admin_name,
                admin_email: data.admin_email,
                admin_image: data.admin_image,
            };
            if (data.admin_password && data.admin_password.trim() !== '') {
                requestPayload.admin_password = data.admin_password.trim();
                requestPayload.admin_password_confirmation = data.admin_password_confirmation?.trim() || '';
            }
            request = apiV2.put('/admins/profile', requestPayload, requestConfig);
        }

        request
            .then((response) => {
                // Get current user data to preserve permissions +
                // is_federated (the profile endpoint doesn't return
                // either, so they'd silently drop without this).
                const currentUser = SessionHelper.currentUser();
                const updatedUserData = {
                    ...response.data,
                    permissions: currentUser?.permissions || [],
                    is_federated: currentUser?.is_federated ?? false,
                };

                // Update session with new data while preserving permissions
                SessionHelper.setUserData(updatedUserData);

                dispatch({
                    type: UPDATE_PROFILE_ADMIN_SUCCESS,
                    payload: updatedUserData
                });
                Swal.fire({
                    icon: "success",
                    title: "Profile Updated!",
                    timer: 2000
                });
                onSuccess?.();
            })
            .catch((error) => {
                dispatch({
                    type: UPDATE_PROFILE_ADMIN_ERROR,
                    payload: []
                });
                errorHandler(dispatch, error.response, API_ERROR);
            })
    }
}
